import getSymbolFromCurrency from 'currency-symbol-map';
import { isNumber, toNumber } from 'lodash';
import { AmericanCountryList, EuropeanUnionList, UKCountryList } from '../constants/quote';
export var getJoveCountryCurrency = function getJoveCountryCurrency(data) {
  var currency = 'GBP';

  if (EuropeanUnionList.includes(data === null || data === void 0 ? void 0 : data.country)) {
    currency = 'EUR';
  } else if (UKCountryList.includes(data === null || data === void 0 ? void 0 : data.country)) {
    currency = 'GBP';
  } else {
    var _data$countries, _data$countries$find, _data$countries$find$, _data$countries$find$2;

    // If it is an EU country, it is all displayed in euros
    currency = data === null || data === void 0 ? void 0 : (_data$countries = data.countries) === null || _data$countries === void 0 ? void 0 : (_data$countries$find = _data$countries.find(function (item) {
      return item.code === (data === null || data === void 0 ? void 0 : data.country);
    })) === null || _data$countries$find === void 0 ? void 0 : (_data$countries$find$ = _data$countries$find.currencies) === null || _data$countries$find$ === void 0 ? void 0 : (_data$countries$find$2 = _data$countries$find$[0]) === null || _data$countries$find$2 === void 0 ? void 0 : _data$countries$find$2.code;
  }

  return currency || 'GBP';
};
export var getJoveCountryCurrencySymbolNative = function getJoveCountryCurrencySymbolNative(data) {
  var symobolNative = '£';

  if (EuropeanUnionList.includes(data === null || data === void 0 ? void 0 : data.country)) {
    symobolNative = '€';
  } else if (UKCountryList.includes(data === null || data === void 0 ? void 0 : data.country)) {
    symobolNative = '£';
  } else {
    var _data$countries2, _data$countries2$find, _data$countries2$find2, _data$countries2$find3;

    // If it is an EU country, it is all displayed in euros
    symobolNative = data === null || data === void 0 ? void 0 : (_data$countries2 = data.countries) === null || _data$countries2 === void 0 ? void 0 : (_data$countries2$find = _data$countries2.find(function (item) {
      return item.code === (data === null || data === void 0 ? void 0 : data.country);
    })) === null || _data$countries2$find === void 0 ? void 0 : (_data$countries2$find2 = _data$countries2$find.currencies) === null || _data$countries2$find2 === void 0 ? void 0 : (_data$countries2$find3 = _data$countries2$find2[0]) === null || _data$countries2$find3 === void 0 ? void 0 : _data$countries2$find3.symbol_native;
  }

  return symobolNative || '£';
};
export var formatCurrencyNumber = function formatCurrencyNumber(num) {
  if (!num) return num;

  if (!isNumber(num)) {
    num = toNumber(num);
  }

  return num.toLocaleString();
};
export var getJoveCountryCurrencySymbolNativeWithRegion = function getJoveCountryCurrencySymbolNativeWithRegion(regions) {
  var symobolNative = '';

  if (regions !== null && regions !== void 0 && regions.includes('EU')) {
    symobolNative = '€';
  } else if (regions !== null && regions !== void 0 && regions.includes('US')) {
    symobolNative = '$';
  } else {
    symobolNative = '£';
  }

  return symobolNative;
};
export var getJoveCountryCurrencySymbolNativeWithCountry = function getJoveCountryCurrencySymbolNativeWithCountry(country) {
  var symobolNative = '';

  if (EuropeanUnionList.includes(country)) {
    symobolNative = '€';
  } else if (AmericanCountryList.includes(country)) {
    symobolNative = '$';
  } else {
    symobolNative = '£';
  }

  return symobolNative;
};
export var getJoveCurrencySymbolWithCurrency = function getJoveCurrencySymbolWithCurrency(currency) {
  return getSymbolFromCurrency(currency) || '£';
};